<template>
  <div>
    <div class="footer">
      <div class="max-w">
        <div class="top only-pc">
          <router-link v-for="(item, index) in nav" :key="'bnav' + index" :to="item.path">{{ item.name }}</router-link>
        </div>
        <div class="center flex">
          <div class="logo">
            <router-link to="/home">
              <img src="@/assets/images/footer/logo.png" alt="logo" /></router-link>
          </div>
          <div class="line only-pc"></div>
          <div class="contact">
            <div class="info" v-show="info.fax">
              <img src="@/assets/images/footer/fax.svg" alt="fax" />传真：{{
                info.fax
              }}
            </div>
            <div class="info" v-show="info.phone">
              <img src="@/assets/images/footer/phone.svg" alt="phone" />座机：{{
                info.phone
              }}
            </div>
            <div class="info" v-show="info.email">
              <img src="@/assets/images/footer/email.svg" alt="email" />邮箱：{{
                info.email
              }}
            </div>
            <div class="info" v-show="info.telephone">
              <img src="@/assets/images/footer/telephone.svg" alt="telephone" />手机号：{{ info.telephone }}
            </div>
            <div class="info" v-show="info.address">
              <img src="@/assets/images/footer/address.svg" alt="address" />地址：{{ info.address }}
            </div>
          </div>
          <div class="line only-pc"></div>
          <div class="qr">
            <img src="@/assets/images/footer/qr.jpg" alt="qr" />
          </div>
        </div>
      </div>
    </div>
    <div class="copyright">
      <div class="max-w">
        <span>版权所有 © 2022 - {{ new Date().getFullYear() }} 乐清电气产业创新发展服务中心</span>
        <a href="https://beian.miit.gov.cn" target="_blank"> {{ info.icp }}</a>
        <a href="/"> {{ info.gaicp }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { getFooter, getColumn } from "@/api/web";
export default {
  data() {
    return {
      nav: [],
      info: {
        address: "",
        gaicp: "",
        icp: "",
        phone: "",
        email: "",
        fax: "",
        people: "",
        telephone: ""
      }
    };
  },
  created() {
    getFooter().then((res) => {
      this.info = res.data;
    });
    getColumn().then((res) => {
      this.nav = res.data;
    });
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background: url("~@/assets/images/footer/bg.png") center no-repeat;
  background-size: cover;
  color: #fff;

  .top {
    padding: 20px 0;

    a {
      color: #fff;
      display: inline-block;
      margin-left: 40px;

      &:hover {
        color: #002a6a;
      }

      &:first-child {
        margin: 0;
      }
    }
  }

  .center {
    padding: 50px 0;

    .line {
      width: 1px;
      height: 100px;
      background: #89b7ff;
    }

    .logo {
      a {
        display: block;
      }
    }

    .contact {
      .info {
        line-height: 2;

        img {
          margin-right: 10px;
          position: relative;
          top: 5px;
        }
      }
    }

    .qr {
      width: 120px;

      img {
        width: 100%;
      }
    }

    @media only screen and (max-width: 1200px) {
      flex-wrap: wrap;

      .logo,
      .contact {
        width: 100%;
      }

      .qr {
        width: 220px;
      }

      .contact {
        padding: 20px 0;
      }
    }
  }
}

.copyright {
  background: #2a6fda;
  color: #fff;
  padding: 14px 0;

  span {
    margin-right: 20px;
  }

  a {
    color: #fff;
    margin-right: 20px;

    &:last-child {
      margin: 0;
    }
  }

  @media only screen and (max-width: 1200px) {

    a,
    span {
      display: block;
      line-height: 1.2;
    }

    a {
      margin-top: 10px;
    }
  }
}
</style>
